<template>
    <div class="detail-table-container">
        <div class="updateGuide" v-if="updateGuide"></div>
        <div class="btns">
            <div class="btn-left">
                <!-- 批量打印函证 -->
                <el-button
                    id="printConfirmation"
                    :style="{ zIndex: updateGuide && updateGuideStep == 3 ? 2004 : 0 }"
                    class="wl-green"
                    :disabled="!hasPermission('download')"
                    icon="el-icon-printer"
                    @click="onPrintConfirmationClick"
                    >
                    {{ $t('confirmation.details_list.btns.print_confirmation') }}
                </el-button>
                <!-- 批量标注寄回毕马威 -->
                <el-button
                    id="statusByBatch"
                    :style="{ zIndex: updateGuide && updateGuideStep == 3 ? 2004 : 0 }"
                    class="wl-green"
                    @click="updateStatusByBatch"
                    icon="el-icon-edit"
                    >
                    {{ $t('confirmation.details_list.btns.update_status') }}
                </el-button>
                <!-- 需再次盖章授权 -->
                <el-button class="wl-green reprint-btn" @click="onReprintClick" icon="el-icon-message" v-show="getUser.userType == '1'">
                    {{ $t('confirmation.details_list.btns.reprint') }}
                    <div :class="['new-tag', `new_${$i18n.locale}`]"></div>
                </el-button>
                <div
                    v-if="updateGuide && [3].includes(updateGuideStep)"
                    :style="{ left: `${updateGuideTitle3Left}PX`, width: `${updateGuideTitle3Width}PX` }"
                    :class="['updateGuideTitle', `updateGuideTitle-step${updateGuideStep}`]"
                >
                    <div class="updateGuideTip">
                        <div class="margin-bottom-10">{{ updateGuideStep }}/5</div>
                        <div class="margin-bottom-10" v-html="$t('confirmation_bubble_3')"></div>
                        <el-button @click="nextClick" class="guide-btn">{{ $t('next') }}</el-button>
                    </div>
                </div>
                <el-button
                    id="downloadConfirmation"
                    class="wl-green"
                    :disabled="!hasPermission('download')"
                    icon="el-icon-download"
                    @click="onDownloadConfirmationClick"
                >
                    {{ $t('BATCH_DOWNLOAD') }}
			
                    <el-tooltip :content="$t('confirmation_cannot_download_tip')">
                        <i v-if="!hasPermission('download')" class="el-icon-warning" style="color: #fd349c"></i>
                    </el-tooltip>
                </el-button>
                
            </div>
            <div class="btn-right">
                <el-button class="wl-green" :disabled="!hasPermission('download')" @click="exportList">
                    <!-- <img src="@/assets/img/icon-export-blue.svg" width="100%" class="btn-icon" /> -->
                    <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon icon-hover" />
                    <!-- <img src="@/assets/img/icon-export-disabled.svg" width="100%" class="btn-icon icon-disabled" /> -->
                    {{ $t('confirmation.details_list.btns.export_list') }}
                </el-button>
                <div :class="[showSearchParams?'filter-and-config':'filter-and-config-without-params']">
                    <TableColumnsControl
                        :class="['table-column-config', anyHidden ? 'table-column-config-active' : '']"
                        :tableName="getUser.userType === '1'?'cfmt_dtl_lst':'cfmt_dtl_lst_client'"
                        :onColumnsLoad="onColumnsLoad"
                        :anyHidden.sync="anyHidden"
                    >
                        <div class="column-btn">
                            <img src="@/assets/img/icon-table-setting.svg" width="100%" class="table-setting-icon" />
                            <span class="table-setting-text">{{ $t('table_columns_display_btn') }}</span>
                        </div>
                    </TableColumnsControl>
                    <div class="split"></div>
                    <div :class="['clean-filter', cleanFilterActive ? 'clean-filter-active' : '']" @click="clearFilter">
                        <img src="@/assets/img/icon-screen.svg" class="table-setting-icon" />
                        {{ $t('clear_filter') }}
                    </div>
                </div>
            </div>
        </div>
        <div style="font-size: 12px; color:#fd349c; font-weight: bold">{{ $t('confirmation.details_list.operate_tip') }}</div>
        <!--更新指导 start-->
        <div
            v-if="updateGuide && [2, 4].includes(updateGuideStep)"
            :class="['updateGuideTitle', `updateGuideTitle-step${updateGuideStep}`]"
            :style="{ height: `${updateGuideTitleHeight}px`, left: `${statusLeft}px` }"
        >
            <div class="updateGuideTip" :style="{ top: `${updateGuideTitleHeight + 10}px` }">
                <div class="margin-bottom-10">{{ updateGuideStep }}/5</div>
                <div class="margin-bottom-10">{{ $t(`confirmation_bubble_${updateGuideStep}`) }}</div>
                <el-button @click="nextClick" class="guide-btn">{{ $t('next') }}</el-button>
            </div>
        </div>
        <div :class="'table'">
            <el-table
                :data="list.data"
                v-loading="list.loading"
                height="100%"
                stripe
                border
                @select-all="(e) => handleSelectAll(e, list.data)"
                @select="handleSelect"
                ref="confirmationTable"
                :key="tableKey"
                :header-cell-class-name="updateGuideClass"
                :empty-text="$t('TABLE_NO_DATA')"
            >
                <!-- 多选 -->
                <el-table-column type="selection" width="40" :fixed="bodyWrapperScrollLeft > 60 ? 'left' : false"></el-table-column>

                <!-- 订单编号 -->
                <el-table-column :width="120" v-if="showColumns.includes('ticketNo') && getUser.userType == '1'" show-overflow-tooltip>
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.ticketNo') }}</div>

                            <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.ticketNo.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input v-model="filter.ticketNo.input" prefix-icon="el-icon-search" clearable></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterTicketNoOpt.length > 0" class="header-select-all">
                                                <span @click="onThFilterCheckAllChange(filter.ticketNo, headerFilterTicketNoOpt, true)">{{
                                                    $t('select_all')
                                                }}</span>
                                                <span @click="onThFilterCheckAllChange(filter.ticketNo, headerFilterTicketNoOpt, false)">{{
                                                    $t('unselect_all')
                                                }}</span>
                                            </div>
                                            <el-checkbox-group v-model="filter.ticketNo.multiCheck">
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="v in headerFilterTicketNoOpt"
                                                    :key="v"
                                                    :label="v"
                                                    >{{ v }}</el-checkbox
                                                >
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <span class="overflow-tooltip-cls">{{ scope.row.ticketNo }}</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 函证 id -->
                <el-table-column :width="200" v-if="showColumns.includes('uniqueId')">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label" v-html="$t('confirmation.details_list.table.unique_id')"></div>
                            <el-popover placement="bottom" ref="uniqueIdPopper" @hide="filterUniqueId(filter.uniqueId)">
                                <template slot="reference">
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.uniqueId.unPrint || (filter.uniqueId.input && filter.uniqueId.input.length > 0)
                                                    ? 'el-icon-arrow-down-active'
                                                    : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>
                                <template>
                                    <el-checkbox v-model="filter.uniqueId.unPrint">{{
                                        $t('confirmation.details_list.not_print')
                                    }}</el-checkbox>
                                    <div class="text-input">
                                        <el-input v-model="filter.uniqueId.input" type="textarea" :rows="5" resize="none" />
                                        <i
                                            v-show="filter.uniqueId.input.length > 0"
                                            class="el-icon-circle-close clear-btn"
                                            @click.prevent="filter.uniqueId.input = ''"
                                        />
                                    </div>
                                    <div class="header-btn-position">
                                        <el-button class="wl-green" @click="filterUniqueId(filter.uniqueId)">{{
                                            $t('btn_search2')
                                        }}</el-button>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <span v-if="scope.row.status === '1' || !hasPermission('download')">{{ scope.row.uniqueId }}</span>
                            <template v-else>
                                <span class="icon-preview uniqueId-text" @click="onPdfPrintClick(scope.row.id)" :title="$t('preview')"><i class="el-icon-view" /></span>
                                <span class="uniqueId-text" @click="downloadFile(scope.row)">
                                    <i class="el-icon-download" />
                                    <span  class="uniqueId-text">{{ scope.row.uniqueId }}</span>
                                </span>

                            </template>
                            <span v-if="ifPrint(scope.row)">{{ $t('printed') }}</span>
                            <span v-if="ifStartWithE(scope.row)">{{ $t('not_printed') }}</span>
                            
                        </div>
                    </template>
                </el-table-column>

                <!-- 函证类型 -->
                <el-table-column :width="150" v-if="showColumns.includes('type')" show-overflow-tooltip>
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.confirmation_type') }}</div>
                            <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.type.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input v-model="filter.type.input" prefix-icon="el-icon-search" clearable></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterKPResponsibleOpt.length > 0" class="header-select-all">
                                                <span @click="onThFilterCheckAllChange(filter.type, headerFilterTypeOpt, true, 'code')">{{
                                                    $t('select_all')
                                                }}</span>
                                                <span @click="onThFilterCheckAllChange(filter.type, headerFilterTypeOpt, false, 'code')">{{
                                                    $t('unselect_all')
                                                }}</span>
                                            </div>
                                            <el-checkbox-group v-model="filter.type.multiCheck">
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="v in headerFilterTypeOpt"
                                                    :key="v.code"
                                                    :label="v.code"
                                                    >{{ $t(`confirmation_type._${v.code}`) }}</el-checkbox
                                                >
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div :class="['td', 'confirmation_type_' + scope.row.type]">
                            <span class="overflow-tooltip-cls">{{ $t(`confirmation_type._${scope.row.type}`) }}</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 函证状态 -->
                <el-table-column :width="210" v-if="showColumns.includes('status')" show-overflow-tooltip>
                    <template #header>
                        <div class="th" style="z-index: 2004;position: relative;">
                            <!-- 编辑icon -->
                            <el-dropdown @command="onStatusBatchEdit" style="margin-right: 5px">
                                <div class="th-edit">
                                    <i class="el-icon-edit-outline"></i>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <template v-for="(v, k) in options.confirmationStatusOptions">
                                        <el-dropdown-item v-if="v.code === '3'" :key="k" :command="v.code">
                                            {{ v.code === '3' ? $t(`confirmation_status._3_3`) : $t(`confirmation_status._${v.code}`) }}
                                        </el-dropdown-item>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.client_authorisation_status') }}</div>

                            <!-- 排序上下箭头 -->
                            <div class="th-sort" @click="switchSort('status')">
                                <i class="el-icon-caret-top th-sort-up" :class="[order.status == 'asc' ? 'th-sort-active' : '']"></i>
                                <i class="el-icon-caret-bottom th-sort-down" :class="[order.status == 'desc' ? 'th-sort-active' : '']"></i>
                            </div>

                            <!-- 筛选 -->
                            <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.status.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input v-model="filter.status.input" prefix-icon="el-icon-search" clearable></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterStatusOpt.length > 0" class="header-select-all">
                                                <span
                                                    @click="onThFilterCheckAllChange(filter.status, headerFilterStatusOpt, true, 'code')"
                                                    >{{ $t('select_all') }}</span
                                                >
                                                <span
                                                    @click="onThFilterCheckAllChange(filter.status, headerFilterStatusOpt, false, 'code')"
                                                    >{{ $t('unselect_all') }}</span
                                                >
                                            </div>
                                            <el-checkbox-group v-model="filter.status.multiCheck">
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="v in headerFilterStatusOpt"
                                                    :key="v.code"
                                                    :label="v.code"
                                                    >
                                                    {{ v.code === '3' ? $t(`confirmation_status._3_3`) : $t(`confirmation_status._${v.code}`) }}
                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.status === '2'" class="confirmation_status_bg_2">
                                <el-select v-model="scope.row.status" @change="singleEditStatus(scope.row)">
                                    <template v-for="(v, k) in options.confirmationStatusOptions">
                                        <!-- 函证ID以E开头时，函证状态禁止修改为3，即已签字盖章并寄往毕马威 -->
                                        <el-option 
                                            v-if="v.code === '2' || v.code === '3'"
                                            :key="k"
                                            :label= "customLabel(scope.row)""
                                            :value="v.code"
                                            :disabled="scope.row.uniqueId.startsWith('E') && v.code === '3'"
                                        >
                                            {{ v.code === '3' ? $t(`confirmation_status._3_3`) : (v.code === '2'&& scope.row.uniqueId.startsWith('L') ? $t(`confirmation_status_2L`) : $t(`confirmation_status_2E`)) }}
                                  
                                        </el-option>
                                    </template>
                                </el-select>
                            </div>
                            <span v-else :class="['overflow-tooltip-cls', `confirmation_status_bg_${scope.row.status}`]">
                                {{ scope.row.status === '3' ? $t(`confirmation_status._3_3`) :(scope.row.status  === '2' ? (scope.row.uniqueId.startsWith('L')?$t(`confirmation_status_2L`) : $t(`confirmation_status_2E`)) :$t(`confirmation_status._${scope.row.status}`)) }}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <!-- 被审计单位名称 -->
                <el-table-column :width="130" v-if="showColumns.includes('confirmationEntityName')" show-overflow-tooltip>
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.entity_name') }}</div>

                            <!-- 筛选 -->
                            <el-popover
                                popper-class="column3-popover"
                                placement="bottom"
                                trigger="click"
                                :visible-arrow="false"
                                @hide="hidePopperSearch"
                            >
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.confirmationEntityName.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input
                                            v-model="filter.confirmationEntityName.input"
                                            prefix-icon="el-icon-search"
                                            clearable
                                        ></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterEntityNameOpt.length > 0" class="header-select-all">
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.confirmationEntityName,
                                                            headerFilterEntityNameOpt,
                                                            true,
                                                            'id'
                                                        )
                                                    "
                                                    >{{ $t('select_all') }}</span
                                                >
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.confirmationEntityName,
                                                            headerFilterEntityNameOpt,
                                                            false,
                                                            'id'
                                                        )
                                                    "
                                                    >{{ $t('unselect_all') }}</span
                                                >
                                            </div>
                                            <el-checkbox-group v-model="filter.confirmationEntityName.multiCheck">
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="v in headerFilterEntityNameOpt"
                                                    :key="v.id"
                                                    :label="v.id"
                                                    >{{ v.entityName }}</el-checkbox
                                                >
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span class="overflow-tooltip-cls">{{ scope.row.confirmationEntityName }}</span>
                    </template>
                </el-table-column>

                <!-- 被函证方名称 -->
                <el-table-column :min-width="130" v-if="showColumns.includes('addrEntityName')" show-overflow-tooltip>
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.addressee_entity_name') }}</div>

                            <!-- 筛选 -->
                            <el-popover placement="bottom" popper-class="column3-popover" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.addressEntityName.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input
                                            v-model="filter.addressEntityName.input"
                                            prefix-icon="el-icon-search"
                                            clearable
                                        ></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterAddressEntityNameOpt.length > 0" class="header-select-all">
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.addressEntityName,
                                                            headerFilterAddressEntityNameOpt,
                                                            true,
                                                            null
                                                        )
                                                    "
                                                    >{{ $t('select_all') }}</span
                                                >
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.addressEntityName,
                                                            headerFilterAddressEntityNameOpt,
                                                            false,
                                                            null
                                                        )
                                                    "
                                                    >{{ $t('unselect_all') }}</span
                                                >
                                            </div>
                                            <el-checkbox-group v-model="filter.addressEntityName.multiCheck">
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="(v, k) in headerFilterAddressEntityNameOpt"
                                                    :key="k"
                                                    :label="v"
                                                    >{{ v }}</el-checkbox
                                                >
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td" style="display: flex; align-items: center;">
                            <!-- 函证ID以E开头时，这里加上link跳转 -->
                            <template v-if="scope.row.uniqueId.startsWith('E') && scope.row.confirmationType !== 'Conf_Com'">
                                <!-- scope.row.authInstructionLink -->
                                <a v-if="pdfNameMap[scope.row.addrEntityName.slice(0, 6)]" :href="'/static/confirmation/' + pdfNameMap[scope.row.addrEntityName.slice(0, 6)]" target="_blank" style="margin-right: 3px;font-size: 16px;color: #3879eb;">
                                    <i class="el-icon-link"></i>
                                </a>
                                <i v-else title="找不到文件" class="el-icon-link" style="margin-right: 3px;font-size: 16px; cursor: not-allowed;"></i>
                            </template>
                            <a v-if="scope.row.confirmationType === 'Conf_Com'" href="/static/confirmation/Client Authorization Instructions (Confirmation.com).pdf" target="_blank" style="margin-right: 3px;font-size: 16px;color: #3879eb;">
                                <i class="el-icon-link"></i>
                            </a>
                            <span class="overflow-tooltip-cls">{{ scope.row.addrEntityName }}</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 资产负债表日 -->
                <el-table-column :width="180" v-if="showColumns.includes('balanceSheetDateStamp')">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.balance_sheet_date') }}</div>

                            <!-- 排序上下箭头 -->
                            <div class="th-sort" @click="switchSort('balanceSheetDate')">
                                <i
                                    class="el-icon-caret-top th-sort-up"
                                    :class="[order.balanceSheetDate == 'asc' ? 'th-sort-active' : '']"
                                ></i>
                                <i
                                    class="el-icon-caret-bottom th-sort-down"
                                    :class="[order.balanceSheetDate == 'desc' ? 'th-sort-active' : '']"
                                ></i>
                            </div>
                            <!-- 筛选 -->
                            <el-popover popper-class="column3-popover" placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.balanceSheetDate.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input v-model="filter.balanceSheetDate.input" prefix-icon="el-icon-search" clearable></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterBalanceSheetDateOpt.length > 0" class="header-select-all">
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.balanceSheetDate,
                                                            headerFilterBalanceSheetDateOpt,
                                                            true,
                                                            null
                                                        )
                                                    "
                                                    >{{ $t('select_all') }}</span
                                                >
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.balanceSheetDate,
                                                            headerFilterBalanceSheetDateOpt,
                                                            false,
                                                            null
                                                        )
                                                    "
                                                    >{{ $t('unselect_all') }}</span
                                                >
                                            </div>
                                            <el-checkbox-group v-model="filter.balanceSheetDate.multiCheck">
                                                <!-- 结果超过1000条可操作性差，且影响性能，应该使用搜索具体搜索，故此权衡性能，slice一下 -->
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="(v, k) in headerFilterBalanceSheetDateOpt.slice(0, 1000)"
                                                    :key="k"
                                                    :label="v"
                                                    >{{ v | formatDate }}</el-checkbox
                                                >
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <span>{{ scope.row.balanceSheetDateStamp | formatDate }}</span>
                        </div>
                    </template>
                </el-table-column>


                <!-- 详细函证状态 仅kpmg员工可见 -->
                <el-table-column
                    :width="340"
                    v-if="getUser.userType === '1' && showColumns.includes('confirmationStatus')"
                    show-overflow-tooltip
                    id="confirmationStatus"
                >
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label" v-html="$t('confirmation.details_list.table.confirmation_status_no_br')"></div>

                            <!-- 排序上下箭头 -->
                            <div class="th-sort" @click="switchSort('confirmationStatus')">
                                <i
                                    class="el-icon-caret-top th-sort-up"
                                    :class="[order.confirmationStatus == 'asc' ? 'th-sort-active' : '']"
                                ></i>
                                <i
                                    class="el-icon-caret-bottom th-sort-down"
                                    :class="[order.confirmationStatus == 'desc' ? 'th-sort-active' : '']"
                                ></i>
                            </div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <span class="overflow-tooltip-cls">{{ scope.row.confirmationStatus }}</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 函证状态的更新时间 -->
                <el-table-column :width="320" v-if="showColumns.includes('currentStatusTimeStamp')">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.current_status_time') }}</div>

                            <!-- 排序上下箭头 -->
                            <div class="th-sort" @click="switchSort('currentStatusTime')">
                                <i
                                    class="el-icon-caret-top th-sort-up"
                                    :class="[order.currentStatusTime == 'asc' ? 'th-sort-active' : '']"
                                ></i>
                                <i
                                    class="el-icon-caret-bottom th-sort-down"
                                    :class="[order.currentStatusTime == 'desc' ? 'th-sort-active' : '']"
                                ></i>
                            </div>

                            <!-- 筛选 -->
                            <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.currentStatusTime.range && filter.currentStatusTime.range.length > 0
                                                    ? 'el-icon-arrow-down-active'
                                                    : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <el-date-picker
                                        v-model="filter.currentStatusTime.range"
                                        type="daterange"
                                        style="width: 100%"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        :start-placeholder="$t('date_filter_begin')"
                                        :end-placeholder="$t('date_filter_end')"
                                        :range-separator="$t('date_filter_middle')"
                                    >
                                    </el-date-picker>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <el-tooltip placement="top">
                                <div slot="content">{{ scope.row.currentStatusTimeStamp | formatDateTime }}</div>
                                <span>{{ scope.row.currentStatusTimeStamp | formatDate }}</span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>

                <!-- 被审计单位负责人 -->
                <el-table-column :width="320" v-if="showColumns.includes('clientInchargeList')">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.client_responsible_person') }}</div>
                            <!-- 筛选 -->
                            <el-popover popper-class="column3-popover" placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.clientIncharge.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input v-model="filter.clientIncharge.input" prefix-icon="el-icon-search" clearable></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterClientInchargeOpt.length > 0" class="header-select-all">
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.clientIncharge,
                                                            headerFilterClientInchargeOpt,
                                                            true,
                                                            'userId'
                                                        )
                                                    "
                                                    >{{ $t('select_all') }}</span
                                                >
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.clientIncharge,
                                                            headerFilterClientInchargeOpt,
                                                            false,
                                                            'userId'
                                                        )
                                                    "
                                                    >{{ $t('unselect_all') }}</span
                                                >
                                            </div>
                                            <el-checkbox-group v-model="filter.clientIncharge.multiCheck">
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="v in headerFilterClientInchargeOpt"
                                                    :key="v.userId"
                                                    :label="v.userId"
                                                    >{{ v.userName }}</el-checkbox
                                                >
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <template v-for="(v, k) in scope.row.clientInchargeList">
                            <el-popover placement="right" trigger="hover" :key="k" v-if="v.userAccount">
                                <template slot="reference">
                                    <span class="single-item">
                                        {{ v.userName }}
                                        <span v-if="k !== scope.row.clientInchargeList.length - 1">,</span>
                                    </span>
                                </template>
                                <template>
                                    <div class="single-item-hover">
                                        {{ v.userAccount }}
                                        <img
                                            src="@/assets/img/kpicon-copy.svg"
                                            width="100%"
                                            class="btn-icon"
                                            @click="doCopy(v.userAccount)"
                                        />
                                    </div>
                                </template>
                            </el-popover>
                            <span class="single-item" :key="k" v-else>
                                {{ v.userName }}
                                <span v-if="k !== scope.row.clientInchargeList.length - 1">,</span>
                            </span>
                        </template>
                    </template>
                </el-table-column>

                <!-- 毕马威负责人 -->
                <el-table-column :width="220" class-name="multi-email-column" v-if="showColumns.includes('kpInchargeList')">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.kpmg_responsible_person') }}</div>
                            <!-- 筛选 -->
                            <el-popover popper-class="column3-popover" placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.kpInchargeList.multiCheck.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <!-- 筛选框啥的 -->
                                    <div class="th-filter">
                                        <el-input v-model="filter.kpInchargeList.input" prefix-icon="el-icon-search" clearable></el-input>
                                        <div class="th-filter-checkbox-group">
                                            <div v-if="headerFilterKPResponsibleOpt.length > 0" class="header-select-all">
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.kpInchargeList,
                                                            headerFilterKPResponsibleOpt,
                                                            true,
                                                            'userId'
                                                        )
                                                    "
                                                    >{{ $t('select_all') }}</span
                                                >
                                                <span
                                                    @click="
                                                        onThFilterCheckAllChange(
                                                            filter.kpInchargeList,
                                                            headerFilterKPResponsibleOpt,
                                                            false,
                                                            'userId'
                                                        )
                                                    "
                                                    >{{ $t('unselect_all') }}</span
                                                >
                                            </div>
                                            <el-checkbox-group v-model="filter.kpInchargeList.multiCheck">
                                                <el-checkbox
                                                    class="th-filter-checkbox"
                                                    v-for="v in headerFilterKPResponsibleOpt"
                                                    :key="v.userId"
                                                    :label="v.userId"
                                                    >{{ v.userName }}</el-checkbox
                                                >
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-popover placement="right" trigger="hover">
                            <template slot="reference">
                                <span class="overflow-tooltip-cls">
                                    {{ scope.row.kpInchargeList.map((i) => i.userName).join(';') }}
                                </span>
                            </template>
                            <template>
                                <div class="single-item-hover" v-for="v in scope.row.kpInchargeList">
                                    <template v-if="scope.row.kpInchargeList.length <= 1">
                                        <span v-if="v.email">
                                            {{ '(' + v.email + ')' }}
                                            <img
                                                src="@/assets/img/kpicon-copy.svg"
                                                width="100%"
                                                class="btn-icon"
                                                @click="doCopy(v.email)"
                                            />
                                        </span>
                                    </template>
                                    <template v-else>
                                        {{ v.userName }}
                                        <span v-if="v.email">
                                            {{ '(' + v.email + ')' }}
                                            <img
                                                src="@/assets/img/kpicon-copy.svg"
                                                width="100%"
                                                class="btn-icon"
                                                @click="doCopy(v.email)"
                                            />
                                        </span>
                                    </template>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
                <!-- 等待被审计单位签字盖章的天数 -->
                <el-table-column :width="340" v-if="showColumns.includes('daysOfPending')" show-overflow-tooltip>
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.days_of_pending_for_authorisation') }}</div>

                            <!-- 排序上下箭头 -->
                            <div class="th-sort" @click="switchSort('daysOfPendingForAuthorisation')">
                                <i
                                    class="el-icon-caret-top th-sort-up"
                                    :class="[order.daysOfPendingForAuthorisation == 'asc' ? 'th-sort-active' : '']"
                                ></i>
                                <i
                                    class="el-icon-caret-bottom th-sort-down"
                                    :class="[order.daysOfPendingForAuthorisation == 'desc' ? 'th-sort-active' : '']"
                                ></i>
                            </div>
                            <!-- 筛选 -->
                            <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.daysOfPendingForAuthorisation.range.length > 0 ? 'el-icon-arrow-down-active' : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <div style="display: flex; align-items: center">
                                        <input-number-range v-model="filter.daysOfPendingForAuthorisation.range" />
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <span class="overflow-tooltip-cls">{{ scope.row.daysOfPendingForAuthorisation }}</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 被审计单位寄回函证的快递单号 -->
                <el-table-column :width="340" v-if="showColumns.includes('courierNo')">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label" v-html="$t('confirmation.details_list.table.courier_no')"></div>

                            <!-- 筛选 -->
                            <el-popover placement="bottom" ref="trackNumPopper" @hide="filterTrackNum(filter.courierNo)">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i :class="['el-icon-arrow-down', filter.courierNo.input ? 'el-icon-arrow-down-active' : '']"></i>
                                    </div>
                                </template>

                                <template>
                                    <div class="text-input">
                                        <el-input v-model="filter.courierNo.input" type="textarea" :rows="5" resize="none" />
                                        <i
                                            v-show="filter.courierNo.input.length > 0"
                                            class="el-icon-circle-close clear-btn"
                                            @click.prevent="filter.courierNo.input = ''"
                                        />
                                    </div>

                                    <div class="header-btn-position">
                                        <el-button class="wl-green" @click="filterTrackNum(filter.courierNo)">{{
                                            $t('btn_search2')
                                        }}</el-button>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <el-input v-model="scope.row.courierNo" :disabled="scope.row.uniqueId.startsWith('E')" @change="changeTrackNum(scope.row)">
                                <i
                                    class="el-icon-s-promotion"
                                    slot="suffix"
                                    style="
                                        color: rgb(56, 121, 235);
                                        cursor: pointer;
                                        position: relative;
                                        top: 50%;
                                        transform: translateY(-50%);
                                        right: 5px;
                                    "
                                />
                            </el-input>
                        </div>
                    </template>
                </el-table-column>

                <!-- 寄出给被函证方的快递单号 -->
                <el-table-column :width="340" v-if="false">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.courier_no_2') }}</div>

                            <!-- 排序上下箭头 -->
                            <!-- <div class="th-sort" @click="switchSort('currentStatusTime')">
                                <i class="el-icon-caret-top th-sort-up" :class="[order.currentStatusTime == 'asc' ? 'th-sort-active' : '']"></i>
                                <i class="el-icon-caret-bottom th-sort-down" :class="[order.currentStatusTime == 'desc' ? 'th-sort-active' : '']"></i>
                            </div> -->

                            <!-- 筛选 -->
                            <el-popover placement="bottom" ref="trackNumPopper2" @hide="filterTrackNum(filter.courierNo)">
                                <template #reference>
                                    <div class="th-filter-down">
                                        :<i :class="['el-icon-arrow-down', filter.courierNo2.input ? 'el-icon-arrow-down-active' : '']"></i>
                                    </div>
                                </template>

                                <template>
                                    <div class="text-input">
                                        <el-input v-model="filter.courierNo2.input" type="textarea" :rows="5" resize="none" />
                                        <i
                                            v-show="filter.courierNo2.input.length > 0"
                                            class="el-icon-circle-close clear-btn"
                                            @click.prevent="filter.courierNo2.input = ''"
                                        />
                                    </div>

                                    <div class="header-btn-position">
                                        <el-button class="wl-green" @click="filterTrackNum2(filter.courierNo2)">{{
                                            $t('btn_search2')
                                        }}</el-button>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <el-tooltip placement="top">
                                <div slot="content">{{ scope.row.courierTrackingNumber }}</div>
                                <span>{{ scope.row.courierTrackingNumber }}</span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>

                <!-- 被函证方签收函证的时间 -->
                <el-table-column :width="320" v-if="getUser.userType === '1'&& showColumns.includes('dateDeliveredToAddressee')">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.dateDeliveredToAddressee') }}</div>

                            <!-- 排序上下箭头 -->
                            <div class="th-sort" @click="switchSort('dateDeliveredToAddressee')">
                                <i
                                    class="el-icon-caret-top th-sort-up"
                                    :class="[order.dateDeliveredToAddressee == 'asc' ? 'th-sort-active' : '']"
                                ></i>
                                <i
                                    class="el-icon-caret-bottom th-sort-down"
                                    :class="[order.dateDeliveredToAddressee == 'desc' ? 'th-sort-active' : '']"
                                ></i>
                            </div>

                            <!-- 筛选 -->
                            <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.dateDeliveredToAddressee.range && filter.dateDeliveredToAddressee.range.length > 0
                                                    ? 'el-icon-arrow-down-active'
                                                    : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <el-date-picker
                                        v-model="filter.dateDeliveredToAddressee.range"
                                        type="daterange"
                                        style="width: 100%"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        range-separator="~"
                                        :start-placeholder="$t('begin_date')"
                                        :end-placeholder="$t('end_date')"
                                    >
                                    </el-date-picker>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <el-tooltip placement="top">
                                <div slot="content">{{ scope.row.dateDeliveredToAddressee | formatDateTime }}</div>
                                <span>{{ scope.row.dateDeliveredToAddressee | formatDateTime }}</span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>

                <!-- 被函证方已接收但尚未回函天数 -->
                <el-table-column :width="480" v-if="showColumns.includes('daysOfReceivedAndProcessedByAddressees')" show-overflow-tooltip>
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.number_of_days_since_received') }}</div>

                            <!-- 排序上下箭头 -->
                            <div class="th-sort" @click="switchSort('daysOfReceivedAndProcessedByAddressees')">
                                <i
                                    class="el-icon-caret-top th-sort-up"
                                    :class="[order.daysOfReceivedAndProcessedByAddressees == 'asc' ? 'th-sort-active' : '']"
                                ></i>
                                <i
                                    class="el-icon-caret-bottom th-sort-down"
                                    :class="[order.daysOfReceivedAndProcessedByAddressees == 'desc' ? 'th-sort-active' : '']"
                                ></i>
                            </div>
                            <!-- 筛选 -->
                            <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                <template #reference>
                                    <div class="th-filter-down">
                                        <i
                                            :class="[
                                                'el-icon-arrow-down',
                                                filter.daysOfReceivedAndProcessedByAddressees.range.length > 0
                                                    ? 'el-icon-arrow-down-active'
                                                    : ''
                                            ]"
                                        ></i>
                                    </div>
                                </template>

                                <template>
                                    <div style="display: flex; align-items: center">
                                        <input-number-range v-model="filter.daysOfReceivedAndProcessedByAddressees.range" />
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <span class="overflow-tooltip-cls">{{ scope.row.daysOfReceivedAndProcessedByAddressees }}</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- 备注 -->
                <el-table-column width="100" align="center" :label="$t('confirmation.details_list.table.input_comments')" :key="14" v-if="showColumns.includes('comment')" fixed="right">
                    <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEAD_COMMENTS') }}
                                    <DatePickerPopover
                                        :value.sync="filter.commentDate.range"
                                        :hidePopperSearch="hidePopperSearch"
                                    ></DatePickerPopover>
                                </div>
                    </template>
                    <template slot-scope="scope">
                    <div class="flex  item-center justify-center">
                        <i
                            :class="[
                                scope.row.todayCommentCount > 0 ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                'el-icon-s-comment'
                            ]"
                            @click="toogleMessageBoardVisible(scope.row)"
                        ></i>
                        <span v-if="scope.row.todayCommentCount"> 
                            <span class="message-today">{{ scope.row.todayCommentCount }}</span>
                            <span>/</span> 
                        </span>
                        <span v-if="scope.row.messageList.length > 0"> {{ scope.row.messageList.length }}</span>
                    </div>
                    </template>
                </el-table-column>

                <!-- 备注-旧版本 -->
                <el-table-column :width="120" v-if="false">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.input_comments') }}</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <el-popover placement="bottom" width="250" :ref="`comment-${scope.row.uniqueId}`">
                                <div slot="reference" class="th-comment-comment-input">
                                    {{ comment[scope.row.uniqueId] || $t('confirmation.details_list.table.input_comments') }}
                                </div>

                                <template>
                                    <div>
                                        <el-input
                                            :placeholder="$t('confirmation.details_list.table.input_comments')"
                                            v-model="comment[scope.row.uniqueId]"
                                            type="textarea"
                                            :rows="5"
                                            resize="none"
                                            maxlength="300"
                                            show-word-limit
                                        >
                                        </el-input>
                                        <div style="text-align: right">
                                            <i
                                                class="el-icon-position"
                                                style="color: #3879eb; cursor: pointer"
                                                @click="sendComment(scope.row)"
                                            />
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>

                <!-- 历史评论 -->
                <el-table-column :width="250" v-if="showColumns.includes('historicalComments')" fixed="right">
                    <template #header>
                        <div class="th">
                            <!-- 表头标题 -->
                            <div class="th-label">{{ $t('confirmation.details_list.table.historical_comments') }}</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="td">
                            <el-popover
                                placement="top"
                                width="400"
                                trigger="hover"
                                v-if="scope.row.historicalComments && scope.row.historicalComments.length > 0"
                            >
                                <div>
                                    <div v-for="(v, k) in scope.row.historicalComments" :key="k">
                                        【
                                        <span>{{ v.sendUserName }} </span>
                                        <span> {{ v.updateDate | formatDateTime }} </span>
                                        】
                                        <span>{{ v.messageContent }}</span>
                                        <br />
                                    </div>
                                </div>
                                <div class="table-td-comment" slot="reference">
                                    【
                                    <span>{{ scope.row.historicalComments[0].sendUserName }} </span>
                                    <span> {{ scope.row.historicalComments[0].updateDate | formatDateTime }} </span>
                                    】
                                    <span>{{ scope.row.historicalComments[0].messageContent }}</span>
                                </div>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page="list.page"
                class="wl-pagination"
                :page-size="list.limit"
                @current-change="
                    (page) => {
                        list.page = page
                        getList()
                    }
                "
                layout="prev, pager, next, slot, total"
                :total="list.total"
            >
                <span>
                    <el-select
                        v-model="list.limit"
                        @change="
                            (e) => {
                                list.page = 1
                                list.limit = e
                                getList()
                            }
                        "
                    >
                        <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </span>
            </el-pagination>
        </div>
        
        <el-popover v-if="deprecatedTicketList.length > 0" placement="top" trigger="hover" width="700">
            <div class="ticket-cls">
                {{ $t('deprecatedTicketTip', { ticketList: deprecatedTicketList.map((item) => item.ticketNo).join(',') }) }}
            </div>
            <div class="deprecated-ticket-content" slot="reference">
                <div class="ticket-info">
                    <span class="ticket-cls">{{
                        $t('deprecatedTicketTip', { ticketList: deprecatedTicketList.map((item) => item.ticketNo).join(',') })
                    }}</span>
                </div>
            </div>
        </el-popover>

        <!--  批量更新状态弹窗 -->
        <el-dialog :title="$t('COMMON_SET_STATUS')" :visible.sync="batchUpdateVisible" width="45%" @close="batchUpdateVisible = false">
            <el-form ref="batchUpdateForm" :model="batchUpdateForm" :rules="batchUpdateRule" label-width="280px">
                <el-form-item
                    :label="$t('confirmation.details_list.table.client_authorisation_status')"
                    prop="status"
                    v-if="checkedStatus2List.length > 0"
                >
                    <el-select v-model="batchUpdateForm.status" :placeholder="$t('COMMON_SELECT')" style="width: 100%" clearable>
                        <template v-for="item in options.confirmationStatusOptions">
                            <el-option
                                v-if="item.code === '3'"
                                :key="item.code"
                                :label="$t('confirmation_status._3_3')"
                                :value="item.code"
                            >
                            </el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item
                    :label="$t('confirmation.details_list.updateStatusForm.courier_no')"
                    prop="courierNoOfTheConfirmationSentToKPMG"
                >
                    <el-input v-model="batchUpdateForm.courierNoOfTheConfirmationSentToKPMG"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="batchUpdateVisible = false">{{ this.$t('btn_cancel') }}</el-button>
                <el-button type="primary" @click="handleBatchUpdateStatus">{{ this.$t('btn_confirm') }}</el-button>
            </span>
        </el-dialog>

        <!-- 清除已打印标记弹窗 -->
        <el-dialog :title="$t('reprint_dialog_title')" :visible.sync="reprint.show" width="45%" @close="reprint.show = false">
            <el-form ref="reprint" :model="reprint" label-width="280px">
                <div class="reprint_dialog_tip" v-html="$t('reprint_dialog_tip')"></div>
                <el-form-item :label="$t('reason')" prop="reason">
                    <el-select v-model="reprint.reason" :placeholder="$t('COMMON_SELECT')" style="width: 100%" clearable multiple>
                        <el-option v-for="item in reprint.options" :key="item.id" :label="$t(item.label)" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('please_input_reason')" prop="othersReason" v-if="reprint.reason.includes(6)">
                    <el-input v-model="reprint.othersReason" :maxlength="300" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="reprint.show = false">{{ this.$t('btn_cancel') }}</el-button>
                <el-button type="primary" @click="handleReprint">{{ this.$t('btn_confirm') }}</el-button>
            </span>
        </el-dialog>
        <!--        留言-->
      <messageBoard v-if="messageBoardVisible" :initData="rowData" :onCancel="toogleMessageBoardVisible" :onAdd="getList" messageType="11"/>
    </div>
</template>

<script>
import { loading, dateFormat, isIE } from '@/utils'
import API from '@/api'
import InputNumberRange from '@/components/common/InputNumberRange'
import { mapGetters } from 'vuex'
import { userPermission } from '@/mixins/userPermission.js'
import batchSelectTableMixins from '@/mixins/batchSelectTableMixins.js'
import TableColumnsControl from '@/components/common/TableColumnsControl'
import { downloadBatchFiles,downloadFileByUrl } from '@/utils/useDownload'
import messageBoard from './messageBoard'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
import pdfNameMap from '../pdf/pdfNameMap'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'

export default {
    name: 'DetailTable',
    props: {
        activeSummary: {
            type: Number,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        getOverviewData: {
            type: Function,
            default: () => {}
        },
        showSearchParams: {
            type: Boolean,
            default: false
        },
        updateGuide: Boolean,
        updateGuideStep: Number,
        nextClick: Function
    },
    components: {
        InputNumberRange,
        TableColumnsControl,
        messageBoard,
        DatePickerPopover,
        GuidanceTooltip
    },
    data() {
        var courierNoValid = (rule, value, callback) => {
            if (value.trim() && !/^[A-Za-z0-9-]{10,30}$/.test(value.trim())) {
                callback(new Error(this.$t('courierNoErr')))
            } else {
                callback()
            }
        }
        return {
            pdfNameMap,
            visible: false,
            updateGuideTitleHeight: 0,
            // 列表数据
            list: {
                data: [],
                page: 1,
                limit: 20,
                total: 0,
                loading: false
            },
            // 分页器选项
            pageOptions: [
                { label: '10/' + this.$t('page'), value: 10 },
                { label: '20/' + this.$t('page'), value: 20 },
                { label: '50/' + this.$t('page'), value: 50 },
                { label: '100/' + this.$t('page'), value: 100 },
                { label: '200/' + this.$t('page'), value: 200 }
            ],
            // 存放表头批量修改的绑定值
            batchEdit: {
                status: '',
                courier_no: '',
                comment: ''
            },
            // 输入的评论内容对应的绑定数据(暂存的未提交数据)，comment 下的 key 是每个函证的 uniqueId
            comment: {},
            /**
             * 下拉选项集
             */
            options: {
                statusList: [],
                typeList: [],
                confirmationStatusOptions: [],
                entityNameList: [],
                addressEntityNameList: [],
                balanceSheetDateList: [],
                ticketNoList: [],
                clientInchargeList: [],
                kPMGResponsiblePersonEmail: []
            },
            // 筛选条件的绑定值
            filter: {
                uniqueId: {
                    unPrint: false,
                    input: '',
                    visible: false,
                    list: []
                },
                status: {
                    input: '',
                    multiCheck: []
                },
                type: {
                    input: '',
                    multiCheck: []
                },
                kpInchargeList: {
                    input: '',
                    multiCheck: []
                },
                confirmationEntityName: {
                    input: '',
                    multiCheck: []
                },
                addressEntityName: {
                    input: '',
                    multiCheck: []
                },
                balanceSheetDate: {
                    input: '',
                    multiCheck: []
                },
                ticketNo: {
                    input: '',
                    multiCheck: []
                },
                clientIncharge: {
                    input: '',
                    multiCheck: []
                },
                confirmationStatus: {
                    input: '',
                    multiCheck: []
                },
                uploadedDate: {
                    range: []
                },
                currentStatusTime: {
                    range: []
                },
                daysOfPendingForAuthorisation: {
                    range: []
                },
                daysOfReceivedAndProcessedByAddressees: {
                    range: []
                },
                courierNo: {
                    input: '',
                    visible: false,
                    list: []
                },
                courierNo2: {
                    input: '',
                    visible: false,
                    list: []
                },
                dateDeliveredToAddressee: {
                    range: []
                },
                commentDate: {
                    range: []
                }
            },
            // 筛选有变化的时候将这个置为 true，这时才会重新加载列表
            filterChanged: false,
            // 筛选条件的备份，清除筛选条件用
            filterBackup: {},
            // 每列的排序，'desc'  'asc'  ''
            order: {
                status: '',
                balanceSheetDate: '',
                confirmationStatus: '',
                daysOfPendingForAuthorisation: '',
                lastUploadedDate: '',
                currentStatusTime: '',
                dateDeliveredToAddressee: '',
                daysOfReceivedAndProcessedByAddressees: ''
            },
            checkedStatus2List: [],
            batchUpdateVisible: false,
            batchUpdateForm: {
                status: '',
                courierNoOfTheConfirmationSentToKPMG: '',
                comment: ''
            },
            showColumns: [
                'uniqueId',
                'status',
                'type',
                'confirmationEntityName',
                'addrEntityName',
                'balanceSheetDateStamp',
                'ticketNo',
                'clientInchargeList',
                'kpInchargeList',
                'confirmationStatus',
                'daysOfPending',
                'lastUploadedDateStamp',
                'currentStatusTimeStamp',
                'courierNo',
                'comment',
                'historicalComments'
            ],
            anyHidden: false,
            tableKey: '0',
            batchUpdateRule: {
                courierNoOfTheConfirmationSentToKPMG: [{ validator: courierNoValid, trigger: 'blur' }]
            },
            deprecatedTicketList: [],
            reprint: {
                show: false,
                reason: [],
                othersReason: '',
                options: [
                    {
                        id: 1,
                        label: 'reprint_reason._1'
                    },
                    {
                        id: 2,
                        label: 'reprint_reason._2'
                    },
                    {
                        id: 3,
                        label: 'reprint_reason._3'
                    },
                    {
                        id: 4,
                        label: 'reprint_reason._4'
                    },
                    {
                        id: 5,
                        label: 'reprint_reason._5'
                    },
                    {
                        id: 6,
                        label: 'reprint_reason._6'
                    }
                ]
            },
            bodyWrapperScrollLeft: 0,
            updateGuideTitle3Left: 0,
            updateGuideTitle3Width: 0,
            messageBoardVisible: false,
            rowData:{}
        }
    },
    mixins: [userPermission, batchSelectTableMixins],
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite',
        }),
        statusLeft() {
            if (this.updateGuideStep === 4) {
                if (this.getUser.userType === '1') {
                    return 820
                } else {
                    return 400
                }
            } else {
                return 0
            }
        },
        // tableHeader kp负责人input过滤后的选项
        headerFilterKPResponsibleOpt() {
            return this.options.kPMGResponsiblePersonEmail
                .map((v) => {
                    v.userName = v.userName ? v.userName : ''
                    v.email = v.email ? v.email : ''
                    return v
                })
                .filter(
                    (v) =>
                        v.userName.toLowerCase().indexOf(this.filter.kpInchargeList.input.toLowerCase()) !== -1 ||
                        v.email.indexOf(this.filter.kpInchargeList.input) !== -1
                )
                .map((v) => {
                    if (v.userName == 'Blank') v.userName = `(${this.$t('common_empty')})`
                    return v
                })
        },
        headerFilterStatusOpt() {
            return this.options.statusList.filter(
                (v) =>
                    v.value.toLowerCase().indexOf(this.filter.status.input.toLowerCase()) !== -1 ||
                    v.code.toLowerCase().indexOf(this.filter.status.input.toLowerCase()) !== -1
            )
        },
        headerFilterTypeOpt() {
            return this.options.typeList.filter(
                (v) =>
                    v.value.toLowerCase().indexOf(this.filter.type.input.toLowerCase()) !== -1 ||
                    v.code.indexOf(this.filter.type.input) !== -1 ||
                    this.$t(`confirmation_type._${v.code}`).toLowerCase().indexOf(this.filter.type.input.toLowerCase()) !== -1
            )
        },
        headerFilterEntityNameOpt() {
            return this.options.entityNameList.filter(
                (v) => v.entityName.indexOf(this.filter.confirmationEntityName.input.toLowerCase()) !== -1
            )
        },
        headerFilterAddressEntityNameOpt() {
            return this.options.addressEntityNameList.filter((v) => v.indexOf(this.filter.addressEntityName.input.toLowerCase()) !== -1)
        },
        headerFilterBalanceSheetDateOpt() {
            return this.options.balanceSheetDateList.filter((v) => {
                let d = dateFormat(new Date(v), 'yyyy-MM-dd')
                return d.indexOf(this.filter.balanceSheetDate.input) !== -1
            })
        },
        headerFilterTicketNoOpt() {
            return this.options.ticketNoList.filter((v) => `${v}`.indexOf(this.filter.ticketNo.input.toLowerCase()) !== -1)
        },
        headerFilterClientInchargeOpt() {
            return this.options.clientInchargeList
                .filter(
                    (v) =>
                        v.userAccount.indexOf(this.filter.clientIncharge.input.toLowerCase()) !== -1 ||
                        v.userName.indexOf(this.filter.clientIncharge.input.toLowerCase()) !== -1
                )
                .map((v) => {
                    if (v.userName == 'Blank') v.userName = `(${this.$t('common_empty')})`
                    return v
                })
        },
        // 有任意筛选条件时“清除筛选条件”按钮高亮显示
        cleanFilterActive() {
            const filter = this.filter
            return (
                filter.uniqueId.unPrint ||
                filter.uniqueId.input.length > 0 ||
                filter.status.input.length > 0 ||
                filter.type.multiCheck.length > 0 ||
                filter.kpInchargeList.multiCheck.length > 0 ||
                filter.confirmationEntityName.multiCheck.length > 0 ||
                filter.addressEntityName.multiCheck.length > 0 ||
                filter.balanceSheetDate.multiCheck.length > 0 ||
                filter.status.multiCheck.length > 0 ||
                filter.ticketNo.multiCheck.length > 0 ||
                filter.clientIncharge.multiCheck.length > 0 ||
                filter.confirmationStatus.multiCheck.length > 0 ||
                filter.uploadedDate.range.length > 0 ||
                (filter.currentStatusTime.range && filter.currentStatusTime.range.length > 0) ||
                filter.daysOfPendingForAuthorisation.range.length > 0 ||
                filter.daysOfReceivedAndProcessedByAddressees.range.length > 0 ||
                filter.courierNo.input.length > 0 ||
                filter.courierNo2.input.length > 0 ||
                (filter.dateDeliveredToAddressee.range && filter.dateDeliveredToAddressee.range.length > 0)||
                (filter.commentDate.range && !!filter.commentDate.range[0])
            )
        }
    },
    created() {
        this.getOptions()
    },
    async mounted() {
        this.changeGuideTitleHeight()
        this.filterBackup = JSON.parse(JSON.stringify(this.filter))
        this.addDashboardListener()
        if(!this.$route.query.homeFilterStatus){
            this.getList()
        }
        
    },
    methods: {
        // 留言
      toogleMessageBoardVisible(row) {
          this.messageBoardVisible = !this.messageBoardVisible
          this.rowData = row
      },
        changeGuideTitleHeight() {
            setTimeout(() => {
                 
                this.updateGuideTitleHeight = document.getElementsByClassName('el-table__header-wrapper')[0].clientHeight
                this.updateGuideTitle3Left = 0 //document.getElementById('downloadConfirmation').clientWidth + 9
                this.updateGuideTitle3Width =
                    document.getElementById('printConfirmation').clientWidth + document.getElementById('statusByBatch').clientWidth + 11
            }, 500)
        },
        ifPrint(row) {
            return (this.getUser.userType === '1' && row.ifKpPrint) || (this.getUser.userType === '2' && row.ifClientPrint)
        },
        ifStartWithE(row) {
            return (row.uniqueId.startsWith("E") )
        },
        // 处理dashboard联动
        addDashboardListener() {
            window.__listenDashboardChangeFilter = (options) => {
                 
                this.clearFilter()
                if (options.type) {
                    this.filter.type.multiCheck = [...options.type]
                }
                if (options.status) {
                    this.filter.status.multiCheck = [...options.status]
                }
                if (options.filterDay) {
                    this.filter.daysOfPendingForAuthorisation.range = [options.filterDay, 99999]
                }
                if (options.confirmation_bar4_input_1) {
                    this.filter.daysOfPendingForAuthorisation.range = [options.confirmation_bar4_input_1, 99999]
                }
                if (options.confirmation_bar4_input_2) {
                    this.filter.daysOfReceivedAndProcessedByAddressees.range = [options.confirmation_bar4_input_2, 99999]
                }
                // this.getList()
            }
        },
        onColumnsLoad(e) {
             
            this.showColumns = e
            this.$nextTick(() => {
                this.$refs.confirmationTable.doLayout()
                this.tableKey = `${Math.random()}`
            })
        },
        switchOpenerLoading(v = null) {
            this.$emit('update:loading', v === null ? !this.loading : v)
        },
        async exportList() {
            let service = loading()
            try {
                service.download()
                this.switchOpenerLoading(true)
                const res = await API.confirmation.exportList(this.queryParams())
                this.switchOpenerLoading(false)
                if (/application\/octet-stream/.test(res.type)) {
                    let blob = new Blob([res])
                    const date = dateFormat(new Date(), 'yyyyMMdd')
                    const filename = `Audit Confirmation _ confirmations list@${date}.xlsx`
                    if (isIE()) {
                        navigator.msSaveBlob(blob, filename)
                    } else {
                        let url = window.URL.createObjectURL(blob)
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    }
                }
            } catch (e) {
            } finally {
                service.close()
            }
        },
        /**
         * 批量更新状态
         */
        async handleBatchUpdateStatus() {
            if (this.checkedStatus2List.length === 0 && !this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG) {
                this.$message.warning(this.$t('please_input_Courier_no'))
                return
            } else if (!this.batchUpdateForm.status && !this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG) {
                this.$message.warning(this.$t('please_choose_status_or_input_Courier_no'))
                return
            }
            this.$refs['batchUpdateForm'].validate(async (valid) => {
                if (valid) {
                    const hasSelectedList = this.hasSelectedList.filter((item) => item.status === '2')

                    let res1 = null
                    let res2 = null
                    if (this.batchUpdateForm.status) {
                        res1 = await API.confirmation.updateInfoBatch({
                            confirmationId: hasSelectedList.map((v) => v.id),
                            status: this.batchUpdateForm.status
                        })
                    }
                    if (this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG) {
                        res2 = await API.confirmation.updateCourierNo({
                            confirmationId: this.hasSelectedList.map((v) => v.id),
                            courierNo: this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG
                        })
                    }
                    // 更新状态和订单编号
                    if(!res1||!res2) return;
                    if (
                        this.batchUpdateForm.status &&
                        res1.code === '1' &&
                        this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG &&
                        res2.code === '1'
                    ) {
                        this.$message.success(this.$t('msg_success'))
                        this.list.data = this.list.data.map((v) => {
                            if (hasSelectedList.map((vv) => vv.id).includes(v.id)) {
                                v.status = this.batchUpdateForm.status
                                v.currentStatusTimeStamp = Date.now()
                            }
                            if (this.hasSelectedList.map((vv) => vv.id).includes(v.id)) {
                                v.courierNo = this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG
                            }
                            return v
                        })
                    } else if (this.batchUpdateForm.status && res1.code === '1') {
                        // 仅更新状态
                        this.$message.success(this.$t('msg_success'))
                        this.list.data = this.list.data.map((v) => {
                            if (hasSelectedList.map((vv) => vv.id).includes(v.id)) {
                                v.status = this.batchUpdateForm.status
                                v.currentStatusTimeStamp = Date.now()
                            }
                            return v
                        })
                    } else if (this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG && res2.code === '1') {
                        // 仅更新快递单号
                        this.$message.success(this.$t('msg_success'))
                        this.list.data = this.list.data.map((v) => {
                            if (this.hasSelectedList.map((vv) => vv.id).includes(v.id)) {
                                v.courierNo = this.batchUpdateForm.courierNoOfTheConfirmationSentToKPMG
                            }
                            return v
                        })
                    } else if (res1 && res1 !== '1') {
                        this.$message.error(this.$t(res1.code))
                        return
                    } else if (res2 && res2 !== '1') {
                        this.$message.error(this.$t(res2.code))
                        return
                    }

                    // 重新加载统计数据
                    this.getOverviewData()
                    this.batchUpdateVisible = false
                }
            })
        },
        // 执行清除已打印标记
        handleReprint() {
            if (this.reprint.reason.length == 0 || (this.reprint.reason.includes(6) && !this.reprint.othersReason)) {
                this.$message.error(this.$t('reprint_please_choose_reason'))
                return
            }
            let reason = this.reprint.reason
                .filter((v) => v != 6)
                .map((v) => {
                    const findReason = this.reprint.options.find((vv) => vv.id == v)
                    return findReason && findReason.label ? this.$t(findReason.label) : ''
                })
                .filter((v) => v != '')
            if (this.reprint.reason.includes(6)) {
                reason.push(`${this.reprint.othersReason}`)
            }
            // 判断是否有电子函证，如有，则提示不可操作
            const hasElectronic = this.hasSelectedList.some(v => v.uniqueId.startsWith('E'))
            if (hasElectronic) {
                this.$message.error(this.$t('onlyNotElectronic'))
                return false;
            }
            API.confirmation
                .reprint({
                    siteId: this.getSite.siteId,
                    // 函证ID以E开头的不可再次授权盖章
                    confirmationId: this.hasSelectedList.filter((v) => !v.uniqueId.startsWith('E')).map((v) => v.id),
                    messageContent: reason.join(';')
                })
                .then((res) => {
                    if (res.code == '1') {
                        this.reprint.show = false
                        this.reprint.reason = []
                        this.reprint.othersReason = ''
                        this.getList()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
        },
        /**
         * 获取下拉选项
         */
        async getOptions() {
            const dict = await API.confirmation.queryDict({ siteId: this.getSite.siteId })
            this.options.confirmationStatusOptions = dict.data.status
            this.options.statusList = dict.data.status
            this.options.typeList = dict.data.type
            const cond = await API.confirmation.getListQueryCondition({ siteId: this.getSite.siteId })
            this.options.addressEntityNameList = cond.data.addrEntityName
            this.options.balanceSheetDateList = cond.data.balanceSheetDateStamp
            this.options.ticketNoList = cond.data.ticketNo
            this.options.clientInchargeList = cond.data.clientInchargeList
            this.options.kPMGResponsiblePersonEmail = cond.data.kpInchargeList
            const entity = await API.confirmation.queryEntity({ siteId: this.getSite.siteId })
            this.options.entityNameList = entity.data
        },
        /**
         * 
         * 点击单个文件下载
         */

        async downloadFile(row){
            if(row.status === '1') return;
            const params = {
                confirmationId: [row.id],
                siteId: this.getSite.siteId
            }
            await downloadFileByUrl(API.confirmation.getPdfOut,params)
        },
        /**
         * 批量下载
         */
        async onDownloadConfirmationClick() {
            if (this.hasSelectedList.filter((v) => v.status != '1').length === 0) {
                this.$message.error(this.$t('check_valid_data'))
                return
            }

            // 单个下载
            if (this.hasSelectedList.filter((v) => v.status != '1').length === 1) {
                this.hasSelectedList
                    .filter((v) => v.status != '1')
                    .forEach(async (v) => {
                        const params = {
                            confirmationId: [v.id],
                            siteId: this.getSite.siteId
                        }
                        await downloadFileByUrl(API.confirmation.getPdfOut,params)
                    })
            }

            // 批量下载
            if (this.hasSelectedList.filter((v) => v.status != '1').length > 1) {
                const fileIdList = this.hasSelectedList
                    .filter((v) => v.status != '1')
                    .map((v) => v.id)
                    .join(',')
                const reqParams = {
                    siteId: this.getSite.siteId,
                    confirmationId: fileIdList
                }

                downloadBatchFiles('/file/free/getPdfDownloadBatch', reqParams)
            }
        },
        /**
         * 批量打印
         */
        async onPrintConfirmationClick() {
            if (!this.hasSelectedList.length) {
                this.$message.error(this.$t('please_check_list_wanna_edit'))
                return
            }
            let sumSize = 0
            this.hasSelectedList.forEach((v) => {
                sumSize += v.size - 0
            })
            if (sumSize > 1073741824) {
                // 1G
                this.$message.error(this.$t('confirmation_print_oversize'))
                return
            }

            // 判断是否有电子函证，如有，则提示不可操作
            const hasElectronic = this.hasSelectedList.some(v => v.uniqueId.startsWith('E'))
            if (hasElectronic) {
                this.$message.error(this.$t('onlyNotElectronic'))
                return false;
            }

            this.switchOpenerLoading(true)
            const res = await API.confirmation.printPdf({
                siteId: this.getSite.siteId,
                // 函证ID以E开头时不可打印
                confirmationId: this.hasSelectedList.filter((v) => v.status != '1' && !v.uniqueId.startsWith('E')).map((v) => v.id)
            })

            this.switchOpenerLoading(false)
            var file = new Blob([res], { type: 'application/pdf' })
            const pdfBlob = window.URL.createObjectURL(file)
            const w = window.open(pdfBlob)
            w.print()
        },
        // 批量更新状态
        updateStatusByBatch() {
            if (!this.hasSelectedList.length) {
                this.$message.error(this.$t('please_check_list_wanna_edit'))
                return
            }
            // 判断是否有电子函证，如有，则提示不可操作
            const hasElectronic = this.hasSelectedList.some(v => v.uniqueId.startsWith('E'))
            if (hasElectronic) {
                this.$message.error(this.$t('onlyNotElectronic'))
                return false;
            }
            // 函证ID以E开头时不可更新状态
            this.checkedStatus2List = this.hasSelectedList.filter((item) => item.status === '2' && !item.uniqueId.startsWith('E'))
            this.batchUpdateVisible = true
            // 打开重置表单
            if (this.$refs['batchUpdateForm']) {
                this.$refs['batchUpdateForm'].resetFields()
            }
        },
        // 清除已打印状态
        onReprintClick() {
            if (!this.hasSelectedList.length) {
                this.$message.error(this.$t('please_check_list_wanna_edit'))
                return
            }
            if (this.hasSelectedList.some((v) => !this.ifPrint(v))) {
                this.$message.error(this.$t('confirmation_only_can_reprint_printed_rows'))
                return
            }
            this.reprint.show = true
        },
        clearFilter() {
            this.$emit('update:activeSummary', null)
            this.filter = JSON.parse(JSON.stringify(this.filterBackup))
            this.list.page = 1
            this.list.limit = 20
            this.$nextTick(() => {
                this.getList()
            })
        },
        hidePopperSearch() {
            this.list.page = 1
            if (this.filterChanged) {
                this.filterChanged = false
                this.getList()
            }
        },

        queryParams() {
            let params = {
                siteId: this.getSite.siteId,
                pageNum: this.list.page,
                pageSize: this.list.limit
            }
            if (this.filter.confirmationEntityName.multiCheck.length > 0) {
                params.entityId = this.filter.confirmationEntityName.multiCheck
            }
            if (this.filter.type.multiCheck.length > 0) {
                params.type = this.filter.type.multiCheck
            }

            /**
             * 状态筛选，如果多选选了，大方块也选了，那么就取两者的交集。
             * 这种方法会出现两者冲突，这时就什么都筛选不出来。
             */
            params.status = []
            if (this.filter.status.multiCheck.length > 0) {
                params.status = this.filter.status.multiCheck
            }
            if (this.activeSummary && this.activeSummary !== 7) {
                params.status =
                    params.status.length === 0 || params.status.includes(`${this.activeSummary}`) ? [`${this.activeSummary}`] : []
            }
            if (this.filter.status.multiCheck.length == 0 && (this.activeSummary === null || this.activeSummary === 7)) delete params.status

            // params.status = params.status.filter(v => v != 'null')
            // if ( this.filter.status.multiCheck.length > 0 && this.activeSummary && this.activeSummary !== 5 && params.status.length == 0) {
            //     this.list.data = []
            //     this.list.total = 0
            //     this.list.loading = false
            //     return
            // }

            if (this.filter.kpInchargeList.multiCheck.length > 0) {
                params.kpInchargeList = this.filter.kpInchargeList.multiCheck
            }
            if (this.filter.clientIncharge.multiCheck.length > 0) {
                params.clientInchargeList = this.filter.clientIncharge.multiCheck
            }
            if (this.filter.addressEntityName.multiCheck.length > 0) {
                params.addrEntityName = this.filter.addressEntityName.multiCheck
            }
            if (this.filter.balanceSheetDate.multiCheck.length > 0) {
                params.balanceSheetDate = this.filter.balanceSheetDate.multiCheck.map((val) => dateFormat(new Date(val), 'yyyy-MM-dd'))
            }
            if (this.filter.ticketNo.multiCheck.length > 0) {
                params.ticketNo = this.filter.ticketNo.multiCheck
            }
            if (this.filter.uniqueId.list.length > 0) {
                params.uniqueId = this.filter.uniqueId.list
            }
            if (this.filter.uniqueId.unPrint) {
                params.unPrint = 'true'
            }
            if (this.filter.confirmationStatus.multiCheck && this.filter.confirmationStatus.multiCheck.length > 0) {
                params.confirmationStatus = this.filter.confirmationStatus.multiCheck
            }
            if (this.filter.daysOfPendingForAuthorisation.range && this.filter.daysOfPendingForAuthorisation.range.length > 0) {
                params.startPendingDay = this.filter.daysOfPendingForAuthorisation.range[0]
                params.endPendingDay = this.filter.daysOfPendingForAuthorisation.range[1]
            }
            if (this.filter.uploadedDate.range && this.filter.uploadedDate.range.length > 0) {
                params.startLastUploadDate = this.filter.uploadedDate.range[0]
                params.endLastUploadEndDate = this.filter.uploadedDate.range[1]
            }
            if (this.filter.currentStatusTime.range && this.filter.currentStatusTime.range.length > 0) {
                params.startCurrentStatusDate = this.filter.currentStatusTime.range[0]
                params.endCurrentStatusDate = this.filter.currentStatusTime.range[1]
            }
            if (this.filter.courierNo.list && this.filter.courierNo.list.length > 0) {
                params.courierNo = this.filter.courierNo.list
            }
            if (
                this.filter.daysOfReceivedAndProcessedByAddressees.range &&
                this.filter.daysOfReceivedAndProcessedByAddressees.range.length == 2
            ) {
                params.startReceivedProcessedDay = this.filter.daysOfReceivedAndProcessedByAddressees.range[0]
                params.endReceivedProcessedDay = this.filter.daysOfReceivedAndProcessedByAddressees.range[1]
            }
            if (this.filter.dateDeliveredToAddressee.range && this.filter.dateDeliveredToAddressee.range.length > 0) {
                params.startDateDeliveredToAddressee = this.filter.dateDeliveredToAddressee.range[0]
                params.endDateDeliveredToAddressee = this.filter.dateDeliveredToAddressee.range[1]
            }
            if (this.filter.courierNo2.list && this.filter.courierNo2.list.length > 0) {
                params.courierTrackingNumber = this.filter.courierNo2.list
            }
            if (this.filter.commentDate.range && this.filter.commentDate.range.length > 0) {
                params.startCommentDate = this.filter.commentDate.range[0]
                params.endCommentDate = this.filter.commentDate.range[1]
            }



            // 查看有没有排序
            const newOrder = Object.keys(this.order).filter((k) => {
                const v = this.order[k]
                return ['asc', 'desc'].includes(v)
            })
            if (newOrder.length > 0) {
                params.orderBy = newOrder[0]
                params.order = this.order[newOrder[0]]
            }
            return params
        },
        /**
         * 获取用户对话消息
        */
       getMessageList(item){
        const list = item.historicalComments?item.historicalComments.filter(comment =>comment.sendUserId):[]
        return list.sort((a,b)=>Date.parse(a.createDate)- Date.parse(b.createDate))
       },
        /**
         * 获取列表
         */
        getList() {
            
            // this.list.loading = true
            let service = loading()
            service.load()

            const params = this.queryParams()
            API.confirmation.getConfirmationList(params).then((res) => {
                const data = res.data.records || []
                this.list.data = data.map(item => (
                    {
                        ...item,
                        messageList: this.getMessageList(item)
                    }
                ))
                this.list.total = res.data.total
                // 回显已选中的
                this.handleEchoData('confirmationTable', this.list.data)
                service.close()
                //更新最新留言
                if(this.rowData.id) {
                    const result = this.list.data.filter(item=>item.id === this.rowData.id);
                    this.rowData.messageList = result.length>0?result[0].messageList:[]
                }
            })
            this.getTicketList()
        },
        /**
         * 授权kcc从用改为不用的ticketNo提示
         **/
        getTicketList() {
            API.confirmation.ticketList({ siteId: this.getSite.siteId }).then((res) => {
                if (res.code === '1') {
                    this.deprecatedTicketList =
                        res.data.discardFlag && res.data.discardFlag.length > 0
                            ? res.data.discardFlag.filter((item) => item.discardFlag === '1')
                            : []
                }
            })
        },
        /**
         * 变更排序
         * default(none) -> desc -> asc -> default(none)
         */
        switchSort(columnName) {
            /**
             * 同时只能对一列进行排序
             * 除了当前正在操作的列，其他列的排序都清除掉
             */
            Object.keys(this.order).forEach((k) => {
                if (k !== columnName) this.order[k] = ''
            })
            switch (this.order[columnName]) {
                case 'asc':
                    this.order[columnName] = ''
                    break
                case 'desc':
                    this.order[columnName] = 'asc'
                    break
                default:
                    this.order[columnName] = 'desc'
                    break
            }
            this.getList()
        },
        // 点击uniqueid预览
        async onPdfPrintClick(e) {
            this.switchOpenerLoading(true)
            const res = await API.confirmation.getPdfOut({
                confirmationId: [e],
                siteId: this.getSite.siteId
            })
            this.switchOpenerLoading(false)
            if (/application\/json/.test(res.data.type)) {
                let reader = new FileReader()
                reader.onload = (e) => {
                    if (e.target.readyState === 2) {
                        let resJson = {}
                        resJson = JSON.parse(e.target.result)
                        this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                    }
                }
                reader.readAsText(res.data)
            } else if (/application\/octet-stream/.test(res.data.type)) {
                var file = new Blob([res.data], { type: 'application/pdf' })
                const pdfBlob = window.URL.createObjectURL(file)
                const w = window.open(pdfBlob)
            }
        },
        /**
         * 表头内全选的勾选变更
         */
        onThFilterCheckAllChange(filter, options, flag, valueKey) {
            let list = options.map((i) => (!valueKey || valueKey === null ? i : i[valueKey]))
            if (flag) {
                filter.multiCheck = Array.from(new Set([...filter.multiCheck, ...list]))
            } else {
                filter.multiCheck = filter.multiCheck.filter((i) => !list.some((item) => item === i))
            }
        },
        /**
         *  Copy邮箱
         */
        doCopy(val) {
            if (!val) return
            let input = document.createElement('input')
            input.value = val
            document.body.appendChild(input)
            input.select()
            document.execCommand('Copy')
            this.$message({
                message: '复制成功',
                type: 'success'
            })
            document.body.removeChild(input)
        },
        // 函证授权进度 点表头批量修改
        onStatusBatchEdit(e) {
            this.handleBatchEdit('status', e)
        },
        // 统一批量修改
        handleBatchEdit(column, value) {
            let confirmationIdList = this.list.data.filter((item) => item.status === '2' && !item.uniqueId.startsWith('E')).map((v) => v.id)
            API.confirmation
                .updateStatus({
                    confirmationId: confirmationIdList,
                    status: value
                })
                .then((res) => {
                    if (res.code === '1') {
                        this.$message.success(this.$t('msg_success'))

                        // 直接更新数据里的状态，不重新加载列表
                        this.list.data = this.list.data.map((v) => {
                            if (v.status === '2') {
                                v.status = value
                                v.currentStatusTimeStamp = Date.now()
                            }
                            return v
                        })
                    } else {
                        this.$message.error(this.$t(res.code))
                        return
                    }
                })
        },
        /**
         * 表格内的单项编辑
         */
        singleEditStatus(row) {
            API.confirmation.updateStatus({ confirmationId: [row.id], status: row.status }).then((res) => {
                if (res.code === '1') {
                    this.$message.success(this.$t('msg_success'))
                    // 直接更新数据里的状态，不重新加载列表
                    this.list.data = this.list.data.map((v) => {
                        if (v.id === row.id) {
                            v.status = row.status
                            v.currentStatusTimeStamp = Date.now()
                            this.getOverviewData()
                        }
                        return v
                    })
                } else {
                    this.$message.error(this.$t(res.code))
                    return
                }
            })
        },
        customLabel(row){
          return  row.status === '3' ? this.$t(`confirmation_status._3_3`) :(row.status  === '2' ? (row.uniqueId.startsWith('L')?this.$t(`confirmation_status_2L`) : this.$t(`confirmation_status_2E`)) :this.$t(`confirmation_status._${row.status}`)) 
        },
        // 修改快递单号
        changeTrackNum(row) {
            if (row.courierNo && !/^[A-Za-z0-9-]{10,30}$/.test(row.courierNo)) {
                this.$message.error(this.$t('courierNoErr'))
                return
            }
            API.confirmation
                .updateCourierNo({
                    confirmationId: [row.id],
                    courierNo: row.courierNo
                })
                .then((res) => {
                    if (res.code === '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.list.data = this.list.data.map((v) => {
                            if (v.id === row.id) v.courierNo = row.courierNo
                            return v
                        })
                    } else {
                        this.$message.error(this.$t(res.code))
                        return
                    }
                })
        },
        filterUniqueId(item) {
            const val = item.input.trim()
            if (val !== '') {
                const list = val
                    .trim()
                    .split(/[,\r\n]+/)
                    .filter((item) => item !== '')
                this.filter.uniqueId.list = list
            } else {
                this.filter.uniqueId.list = []
            }
            this.list.page = 1
            this.getList()
            this.$refs['uniqueIdPopper'].doClose()
        },

        filterTrackNum(item) {
            const val = item.input.trim()
            if (val !== '') {
                const list = val
                    .trim()
                    .split(/[,\r\n]+/)
                    .filter((item) => item !== '')
                this.filter.courierNo.list = list
            } else {
                this.filter.courierNo.list = []
            }
            this.list.page = 1
            this.getList()
            this.$refs['trackNumPopper'].doClose()
        },
        filterTrackNum2(item) {
            const val = item.input.trim()
            if (val !== '') {
                const list = val
                    .trim()
                    .split(/[,\r\n]+/)
                    .filter((item) => item !== '')
                this.filter.courierNo2.list = list
            } else {
                this.filter.courierNo2.list = []
            }
            this.list.page = 1
            this.getList()
            this.$refs['trackNumPopper2'].doClose()
        },
        // 单条记录发送评论
        sendComment(row) {
            let params = [
                {
                    confirmationId: row.id,
                    messageContent: this.comment[row.uniqueId]
                }
            ]
            // 模拟点击页面其他部分关闭弹层, 表格蓝记载导致doClose无效
            document.body.click()
            API.confirmation.sendComments({ confirmationMessages: params }).then((res) => {
                if (res.code === '1') {
                    this.comment[row.uniqueId] = ''
                    this.$message.success(this.$t('msg_success'))
                    this.getList()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        updateGuideClass({ row, column, rowIndex, columnIndex }) {
            if (
                (this.updateGuide && this.updateGuideStep == 2 && columnIndex == 0) ||
                (this.updateGuide &&
                    this.updateGuideStep == 4 &&
                    ((this.getUser.userType === '2' && columnIndex == 6) || (this.getUser.userType === '1' && columnIndex == 7)))
            ) {
                return 'updateGuideHeaderTitle'
            }
            return ''
        },
        activeSummaryChange(v) {
            this.filter = JSON.parse(JSON.stringify(this.filterBackup))
            this.list.page = 1
            this.list.limit = 20
            this.filter.status.multiCheck = v == 7 ? [] : [`${v}`]
            this.$nextTick(() => {
                this.getList()
            })
        }
    },
    watch: {
        filter: {
            deep: true,
            handler(v) {
                this.filterChanged = true
            }
        }
    }
}
</script>

<style scoped>
.filter-and-config{
    display: flex;
    position: absolute;
    top: -180px;
}
.filter-and-config-without-params{
    display: flex;
    position: absolute;
    top: -50px;
}
.icon-preview {
  margin-right: 10px;
  cursor: pointer;
}
.detail-table-container {
    height: 100%;
    position: relative;
}
.detail-table-container .btns {
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    justify-content: space-between;
}
.detail-table-container .btns .btn-left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}

.reprint-btn {
    position: relative;
}
::v-deep .new-tag {
    display: inline-block;
    position: absolute;
    height: 36px;
    width: 72px;
    z-index: 6;
    right: -36px;
    top: -23px;
}
/* ::v-deep .new_zh {
    background: url('~@/assets/img/icon-new-zh-left.svg') center center/100% 100% no-repeat;
}
::v-deep .new_en {
    background: url('~@/assets/img/icon-new-left.svg') center center/100% 100% no-repeat;
} */
.detail-table-container .btns .btn-right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.cancel-btn:hover .btn-icon,
.cancel-btn:focus .btn-icon,
.cancel-btn:disabled .btn-icon,
.cancel-btn:disabled:hover .btn-icon,
.cancel-btn:disabled:hover .btn-icon.icon-hover {
    display: none;
}
.cancel-btn .btn-icon.icon-hover,
.cancel-btn .btn-icon.icon-disabled {
    display: none;
}
.cancel-btn:hover .btn-icon.icon-hover,
.cancel-btn:focus .btn-icon.icon-hover {
    display: inline-block;
}
.cancel-btn:disabled .btn-icon.icon-disabled {
    display: inline-block;
}
.detail-table-container .table {
    height: calc(100% - 40px - 85px);
    border-left: solid 1px #ebedf2;
    border-right: solid 1px #ebedf2;
    position: absolute;
    width: 100%;
}
.detail-table-container .table .th {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.detail-table-container .table .th .th-sort {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.detail-table-container .table .th .th-sort .th-sort-up,
.detail-table-container .table .th .th-sort .th-sort-down {
    font-size: 16px;
    color: #ccced2;
    cursor: pointer;
    margin-left: 5px;
}
.detail-table-container .table .th .th-sort .th-sort-up {
    margin-bottom: -3px;
}
.detail-table-container .table .th .th-sort .th-sort-down {
    margin-top: -3px;
}
.detail-table-container .table .th .th-sort .th-sort-active {
    color: #3879eb;
}
.detail-table-container .table .th .th-edit {
    margin-left: 5px;
    cursor: pointer;
}
.detail-table-container .table .th .el-icon-edit-outline {
    font-size: 16px;
    color: #3879eb;
}
.table ::v-deep .el-table .multi-email-column .cell {
    padding: 0 10px;
}
.table .single-item {
    margin-right: 5px;
    cursor: pointer;
}
.table .single-item:hover {
    color: #3879eb;
}

.td-hover .btn-icon,
.single-item-hover .btn-icon {
    margin-left: 10px;
    cursor: pointer;
}

.th-filter-checkbox-group {
    margin: 12px 0 0 10px;
    position: relative;
}
.header-select-all {
    position: absolute;
    top: 0;
    right: 0;
    color: #409eff;
    z-index: 3;
}
.header-select-all span {
    cursor: pointer;
}
.header-select-all span:first-child {
    margin-right: 10px;
}
.th-filter-checkbox-group .el-checkbox-group {
    display: flex;
    flex-direction: column;
    padding-top: 20px;
}
.th-filter-checkbox:not(:last-child) {
    margin-bottom: 12px;
}
.uniqueId-text {
    text-decoration: underline;
    color: #3879eb;
    cursor: pointer;
}
.header-btn-position {
    text-align: right;
    margin-top: 10px;
}
.th-comment-comment-input {
    width: 90%;
    height: 32px;
    border: solid 1px rgb(220, 223, 230);
    border-radius: 5px;
    padding: 5px 10px;
    cursor: text;
    line-height: 24px;
    color: rgb(192, 196, 204);
}
.text-input {
    position: relative;
}
.text-input .clear-btn {
    position: absolute;
    bottom: 5px;
    right: 5px;
    z-index: 2;
    cursor: pointer;
    color: #ccc;
}
.text-input .clear-btn:hover {
    color: #878d99;
}
span.overflow-tooltip-cls {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.table-td-comment {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.deprecated-ticket-content {
    position: absolute;
    left: 25%;
    bottom: 0;
    display: inline-block;
    width: 50%;
    /* width: 1065px; */
    height: 48px;
    line-height: 48px;
    overflow: hidden;
}
.ticket-cls {
    color:#fd349c;
}
.ticket-info {
    position: absolute;
    left: 100%;
    top: 0;
    width: fit-content;
    width: -moz-fit-content;
    height: 48px;
    line-height: 48px;
    font-size: 12px;
    white-space: nowrap;
    transform: translateX(-100%);
    animation: moving 40s linear infinite;
}
.ticket-info:hover {
    animation-play-state: paused;
}
@keyframes moving {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(calc(-100% - 50%));
    }
}
.table-column-config {
    line-height: 30px;
    cursor: pointer;
    /* font-size: 21px; */
}
.table-column-config-active .table-setting-text {
    font-weight: 600;
    color: #5879eb;
}
.split {
    width: 1px;
    height: 14px;
    border-left: solid 1px #ccced2;
    margin: auto 8px;
}
.clean-filter {
    /* font-size: 12PX; */
    line-height: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: black;
}

.column-btn {
    /* font-size: 12px; */
    display: flex;
    flex-direction: row;
    align-items: center;
}
.column-btn .table-setting-icon {
    width: 20px;
    margin-right: 5px;
}
.column-btn:hover {
    color: rgb(0, 94, 184);
}
.updateGuideTitle {
    position: absolute;
    background-color: white;
    height: 45px;
    z-index: 2003;
    border: 2px solid #3879eb !important;
    border-radius: 10px;
}
.updateGuideTitle-step2 {
    left: 0;
    width: 50px;
}
.updateGuideTitle-step4 {
    left: 820px;
    width: 170px;
}
.updateGuideTitle-step3 {
    top: -2px;
    height: 34px;
    border-radius: 5px !important;
}
.updateGuideIcon {
    height: 24px;
    width: 24px;
    z-index: 101;
    border: 2px solid #3879eb !important;
    border-radius: 10px;
    position: relative;
}
.updateGuideIcon .updateGuideTip {
    z-index: 101;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    right: 0;
    top: 26px;
    width: 240px;
    border-radius: 10px;
    line-height: normal;
    font-size: 14px;
    line-height: normal;
}
.margin-bottom-10 {
    margin-bottom: 10px;
}
.guide-btn {
    float: right;
    color: #3879eb;
}
.updateGuideTitle .updateGuideTip {
    z-index: 2003;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    left: 0;
    top: 42px;
    width: 240px;
    border-radius: 10px;
    text-align: left;
    font-size: 14px;
    line-height: normal;
}

::v-deep .el-button + .el-button {
    margin-left: 10px !important;
}
::v-deep .reprint_dialog_tip {
    color: #147bc5;
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 40px;
}
.wl-icon-messageBoard {
  font-size: 18px;
  color: #3879eb;
  cursor: pointer;
}

.wl-icon-messageBoardNull {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}
</style>
<style>
.column3-popover {
    max-height: 60vh;
    overflow-y: scroll;
}
.column3-popover .th-filter {
    height: 100%;
}
.updateGuideHeaderTitle .cell {
    z-index: 2003;
}

.confirmation_status_bg_2 {
    position: relative;
}
.confirmation_status_bg_2 .el-input__inner {
    padding-left: 20PX;
    color: #fd349c;
}
.confirmation_status_bg_2:before {
    content: "\e7a3";
    font-family: element-icons !important;
    color: #fd349c;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}

.confirmation_status_bg_1 {
    position: relative;
    padding-left: 20PX;
    color: #989898;
}

.confirmation_status_bg_3 {
    position: relative;
    padding-left: 20PX;
    color: #00b8f5;
}

.confirmation_status_bg_4 {
    position: relative;
    padding-left: 20PX;
    color: #1e49e2;
}

.confirmation_status_bg_5 {
    position: relative;
    padding-left: 20PX;
    color: #00338d;
}

.confirmation_status_bg_6 {
    position: relative;
    padding-left: 20PX;
    color: #269924;
}

.confirmation_status_bg_1::before {
    content: "\e7a3";
    font-family: element-icons !important;
    color: #989898;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
.confirmation_status_bg_3::before {
    content: "\e71f";
    font-family: element-icons !important;
    color: #00b8f5;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
.confirmation_status_bg_4::before {
    content: "\e71f";
    font-family: element-icons !important;
    color: #1e49e2;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
.confirmation_status_bg_5::before {
    content: "\e71f";
    font-family: element-icons !important;
    color: #00338d;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
.confirmation_status_bg_6::before {
    content: "\e79c";
    font-family: element-icons !important;
    color: #269924;
    font-size: 14PX;
    position: absolute;
    top: 1px;
    left: 5px;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}

.cell:has(.td.is-electronic) {
    color: #269924;
}

/* confirmation_type_0: '非银行类函证', */
/* confirmation_type_1: '银行函证-纸质函', */
/* confirmation_type_2: '银行函证-电子函' */
.confirmation_type_0 {
    color: #00b8f5;
}
.confirmation_type_1 {
    color: #1e49e2;
}
.confirmation_type_2 {
    color: #269924;
}
</style>
